import React from "react";
import ProductSpread from "../ProductSpread/ProductSpread";
import all_products from "../Assets/all_stickers"

const AllProducts = () => {
  return (
    <div>
      <ProductSpread products={ all_products } />
    </div>
  );
};

export default AllProducts;
